import { motion } from "framer-motion";
import { Heart } from "lucide-react";
import { FaGooglePlay, FaApple } from "react-icons/fa";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_faith-bubbles-io/artifacts/j7evy55i_WINNERS%20LOGO%20REAL.png";

export const GivingBanner = () => {
  return (
    <section
      id="giving"
      data-testid="giving-section"
      className="py-12 md:py-16 bg-white relative overflow-hidden"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="bg-gradient-to-br from-red-600 via-red-700 to-red-800 rounded-[2.5rem] p-8 md:p-12 text-white text-center relative overflow-hidden shadow-[0_20px_60px_rgb(220,38,38,0.25)]"
        >
          {/* Decorative circles */}
          <div className="absolute top-0 right-0 w-48 h-48 rounded-full bg-white/5 -translate-y-1/2 translate-x-1/4" />
          <div className="absolute bottom-0 left-0 w-36 h-36 rounded-full bg-white/5 translate-y-1/2 -translate-x-1/4" />

          <div className="relative z-10">
            <div className="flex items-center justify-center gap-2 mb-3">
              <Heart size={20} className="text-red-200" />
              <span className="font-accent text-xl text-red-200">Give Generously</span>
            </div>

            <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-3">
              Tithes & Offerings
            </h2>
            <p className="text-red-100 text-sm md:text-base max-w-lg mx-auto mb-8">
              Give your tithes, offerings and donations easily through the Winners DP App.
              Available on both Android and iOS.
            </p>

            {/* App logo */}
            <div className="flex justify-center mb-6">
              <img
                src={LOGO_URL}
                alt="Winners DP"
                className="h-20 w-20 object-contain rounded-2xl shadow-lg bg-white p-1"
                data-testid="giving-app-logo"
              />
            </div>

            <p className="text-lg font-bold mb-5">Winners DP App</p>

            {/* Store buttons */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="https://play.google.com/store/apps/details?id=com.xcelcmp.app&utm_source=emea_Med&pli=1"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="giving-google-play-btn"
                className="flex items-center gap-3 bg-black text-white rounded-2xl px-6 py-3.5 hover:bg-stone-900 transition-transform duration-200 hover:-translate-y-1 hover:shadow-xl min-w-[200px]"
              >
                <FaGooglePlay size={24} />
                <div className="text-left">
                  <p className="text-[10px] uppercase tracking-wider opacity-80">Download on</p>
                  <p className="text-base font-semibold -mt-0.5">Google Play</p>
                </div>
              </a>

              <a
                href="https://apps.apple.com/gb/app/winners-dp/id6469002825"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="giving-app-store-btn"
                className="flex items-center gap-3 bg-black text-white rounded-2xl px-6 py-3.5 hover:bg-stone-900 transition-transform duration-200 hover:-translate-y-1 hover:shadow-xl min-w-[200px]"
              >
                <FaApple size={28} />
                <div className="text-left">
                  <p className="text-[10px] uppercase tracking-wider opacity-80">Download on</p>
                  <p className="text-base font-semibold -mt-0.5">App Store</p>
                </div>
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
